import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import { BarChart } from '@mui/x-charts/BarChart';
import { useProdutosStore } from '../store/ProdutosStore';
import FiltrosBusca from './FiltrosDoGrafico';

export default function GraficoComFiltro() {
    const { dadosProdsVendidosParaGrafico, FiltrarProdutosParaGrafico, carregando } = useProdutosStore();

    // Função para gerar cor única para cada item
    const gerarCor = (index) => `hsl(${(index * 137.5) % 360}, 60%, 50%)`;


    async function HandleSearch(dados) {
        FiltrarProdutosParaGrafico(dados);
    }

    if (dadosProdsVendidosParaGrafico.length > 0) {
        return (
            <Card
                variant="outlined"
                sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
            >
                <FiltrosBusca
                    onSearch={HandleSearch}
                    isLoading={carregando === 'find'}
                />
                <BarChart
                    height={350}
                    xAxis={[{ scaleType: 'band', data: ['Produtos'] }]}
                    series={dadosProdsVendidosParaGrafico.map((p, index) => ({
                        label:`${p.label}(${p.data})`,
                        data: [p.data],
                        color: gerarCor(index),
                        barWidth: 50,
                    }))}
                    // aqui entra a config de label
                    barLabel={(item) => {
                        const total = dadosProdsVendidosParaGrafico.reduce(
                            (acc, prod) => acc + prod.data,
                            0
                        );
                        const porcentagem = ((item.value / total) * 100).toFixed(1) + '%';
                        return porcentagem;
                    }}
                    slotProps={{
                        barLabel: {
                            position: 'inside', // pode ser 'inside', 'outside' ou 'center'
                            style: { fill: '#fff', fontWeight: 'bold', fontSize: 12 },
                        },
                    }}
                />

            </Card>
        );
    }

    return (
        <Card
            variant="outlined"
            sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
        >
            <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                * Para ver os registros faça uma venda.
            </Typography>
        </Card>
    );
}
